export interface ParsedEmail {
  address: string;
  label?: string;
}

/**
 * Normalize/clean label:
 * - Trim
 * - Remove outer quotes
 * - Collapse multiple spaces
 */
function normalizeLabel(label: string): string {
  let cleaned = label.trim();

  // Remove surrounding quotes if present
  if (
    (cleaned.startsWith('"') && cleaned.endsWith('"')) ||
    (cleaned.startsWith("'") && cleaned.endsWith("'"))
  ) {
    cleaned = cleaned.substring(1, cleaned.length - 1);
  }

  // Collapse internal whitespace
  cleaned = cleaned.replace(/\s+/g, " ");

  return cleaned;
}

// RFC-5322 compliant email regex (commonly accepted practical version)
const rfc5322EmailRegex = new RegExp(
  // eslint-disable-next-line no-useless-escape
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/
);

export const validateEmail = (email: string): ParsedEmail | null => {
  const trimmed = email.trim();

  // Pattern: label <email>
  const withLabelRegex = /^(.+?)\s*<\s*(.+?)\s*>$/;

  let label: string | undefined;
  let address: string;

  const match = trimmed.match(withLabelRegex);

  if (match) {
    label = normalizeLabel(match[1]);
    address = match[2].trim();
  } else {
    address = trimmed;
  }

  if (!rfc5322EmailRegex.test(address)) {
    return null;
  }

  return {
    address,
    ...(label ? { label } : {}),
  };
};
